export default __webpack_public_path__ + "static/media/DTGO_logo_with_text.f6b43945.png";